import axios from 'axios';
import { BASE_API_URL } from '../constants/endpoints';

export const axiosSingleton = axios.create({
  timeout: 60000,
  baseURL: BASE_API_URL,
  withCredentials: true
});

export const generalPostRequest = args => {
  const method = 'POST';
  const headers = new window.Headers();
  const credentials = 'include';
  const mode = 'cors';

  const url = args.endpointUrl;
  const body = JSON.stringify(args.body);

  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');

  const options = {
    headers,
    method,
    credentials,
    mode,
    body
  };

  return window
    .fetch(url, options)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      return response.error();
    })
    .then(json => json)
    .catch(error => {
      throw error;
    });
};

export const generalGetRequest = args => {
  const method = 'GET';
  const headers = new window.Headers();

  const url = args.endpointUrl;

  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');

  const options = {
    headers,
    method
  };

  return window
    .fetch(url, options)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      return response.error();
    })
    .then(json => json)
    .catch(error => {
      throw error;
    });
};



// WEBPACK FOOTER //
// ./src/api/generalApi.js